// Shared EXIF GPS/date helpers, used by both the EXIF Viewer (full metadata
// display) and the Case Timeline Builder (auto-suggesting an event's
// location/date from an attached photo). Runs entirely client-side via exifr.

export function toDecimal(dmsArr, ref) {
  if (!dmsArr || dmsArr.length < 3) return null;
  const [d, m, s] = dmsArr;
  let dec = d + m / 60 + s / 3600;
  if (ref === 'S' || ref === 'W') dec = -dec;
  return dec;
}

// Parses a File/Blob's EXIF data for just GPS + capture date — the two fields
// the Timeline Builder can auto-suggest from an attached photo. Never throws;
// returns nulls on any failure (a non-photo file, no EXIF block, etc.).
export async function parseGpsAndDate(file) {
  let all;
  try {
    const exifr = await import('exifr');
    all = await exifr.parse(file, { tiff: true, xmp: true, gps: true, translateValues: true });
  } catch {
    return { gps: null, datetime: null };
  }
  if (!all) return { gps: null, datetime: null };

  let gps = null;
  if (all.latitude != null && all.longitude != null) {
    gps = { lat: all.latitude, lng: all.longitude };
  } else if (all.GPSLatitude && all.GPSLongitude) {
    const lat = toDecimal(all.GPSLatitude, all.GPSLatitudeRef);
    const lng = toDecimal(all.GPSLongitude, all.GPSLongitudeRef);
    if (lat != null && lng != null) gps = { lat, lng };
  }

  const datetime = all.DateTimeOriginal || all.CreateDate || all.DateTime || null;
  return { gps, datetime };
}
